import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-terms-short-pdf',
  templateUrl: './termsShortPdf.component.html',
  styleUrls: ['./termsShortPdf.component.css']
})
export class TermsShortPdfComponent implements OnInit {

  constructor() { }

  ngOnInit() {

  }
}
